module.exports = __webpack_public_path__ + "img/OGMA-2000.470cf0f4.jpg";